import React from 'react';
import { motion } from 'framer-motion';
const costs = ["Nights lost searching for progressions that actually work, flow, and fit your specific students' level", 'Lessons that feel repetitive — because you keep going back to the exercises you already know', 'Visible improvisation that quietly chips away at your confidence as an instructor', 'No variety between weeks — and students who slowly lose motivation without knowing exactly why', 'Weekends spent planning instead of resting, recharging, or living your life'];
export function PainPoints() {
  return <section className="py-24 px-4 bg-ivory" data-id="element-186" data-mp="1nzjzsdkbt9bz">
      <div className="max-w-3xl mx-auto" data-id="element-187" data-mp="1o0vcj2vr1rf8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-188" data-mp="1o1wpxe08mq04">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-forest" data-id="element-189" data-mp="3ibs066ff2if5">
            Does this sound familiar?
          </h2>
          <p className="text-lg text-ink leading-relaxed bg-white p-6 rounded-2xl border border-gold-aged/40 shadow-[0_4px_20px_rgba(18,53,36,0.06)] text-left" data-id="element-190" data-mp="1yzvidgbxglte">
            Sunday evening. 10pm. You have a riding lesson tomorrow morning. And
            you're still there, searching online, trying to build a lesson
            structure that actually flows — that fits your students' level, that
            feels professional, that doesn't look like you put it together in
            twenty minutes.
            <br data-id="element-191" data-mp="1b3hluxgk4qgj" />
            <br data-id="element-192" data-mp="1b415ciluvmwo" />
            <span className="text-pine font-medium" data-id="element-193" data-mp="1b4kdx8pm8yy1">
              Not because you don't know how to teach riding.
            </span>{' '}
            Because nobody ever gave you a complete, structured, ready-to-teach
            system. You've been building every single lesson from scratch. The
            time you should be resting — you spend planning. And the worst part
            isn't the exhaustion. The worst part is walking into the arena
            feeling like you could have been better prepared.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-194" data-mp="1y3qa65w9rdjv">
          <h3 className="text-xl font-bold text-forest mb-8 text-center" data-id="element-195" data-mp="274o7k5c7cmth">
            The real cost of not having the right resource:
          </h3>

          <ul className="space-y-4" data-id="element-196" data-mp="1ag8hm856kbfu">
            {costs.map((point, i) => <motion.li key={point} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-leather/50 p-4 rounded-xl border border-leather-dark/25" data-id="element-197" data-mp="1ehag2mr9wjgr" data-mpi={i}>
                <span className="text-red-700 mt-1" aria-hidden="true" data-id="element-198" data-mp="vphq717i3ed9">
                  🔴
                </span>
                <span className="text-ink" data-id="element-199" data-mp="o6i58r4e5ers">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-gold-aged/40" data-id="element-200" data-mp="j86xqn1kjgcq">
            <p className="text-2xl font-serif font-bold text-forest" data-id="element-201" data-mp="e7j4rvts4pfv">
              Stop giving away your free time. Your dedication is already there.
              What you need now is the right tool.
            </p>
            <p className="text-xl mt-4 text-pine font-medium" data-id="element-202" data-mp="58flaqqpa80u">
              Solve an entire year of riding lessons in just 5 minutes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}